<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12" class="py-0">
        <BaseCard>
          <FichaTecnicaFormulario
            v-auth-acl="'gh-ind-hoj_norm-insert'"
            @open="open"
            @close="close"
          ></FichaTecnicaFormulario>
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Proyecto',
  components: {
    FichaTecnicaFormulario: () => import('../components/FichaTecnicaFormulario')
  },
  data: () => ({
    page: {
      title: 'Indicadores'
    },
    breadcrumbs: [
      {
        text: 'Indicadores',
        disabled: true
      },
      {
        text: 'Hoja de Normalización',
        disabled: false
      }
    ]
  }),
  methods: {
    open() {},
    close() {}
  }
};
</script>
